export default __webpack_public_path__ + "static/media/BlackMarker.b3f28275.svg";